import React from 'react'

function About() {
    return (
        <div>
            About Me
        </div>
    )
}

export default About
